/**
 * Icons for different types of user devices platforms.
 * Used in lication history map tooltip.
 *
 * @type Object
 */
export default {
  ios:     'icon-ios',
  android: 'icon-android',
  mac:     'icon-mac',
  windows: 'icon-windows'
}